var lib_core  = require("lib-core");
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");

var AbstractEditorController = require("./../../abstract/abstractEditorController.js");
var InspectorView            = require("./inspectorView.js");
var InspectorModel           = require("./inspectorModel.js");
var InspectorStateMachine    = require("./inspectorStateMachine.js");

var InspectorController = function(archLayers, dependencies, configuration) {
    this.setDefaultConfiguration({
        draggable: false,
        location: "top right"
    });
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        INSPECTOR_FOCUS: {id: 'abs_18', name: "INSPECTOR_FOCUS" },
        INSPECTOR_BLUR : {id: 'abs_18b', name: "INSPECTOR_BLUR" },
        INSPECTOR_ENTER: {id: 'abs_18c', name: "INSPECTOR_ENTER"},
        CHANGE_PROPERTY: {id: 'abs_19', name: "CHANGE_PROPERTY" },
    });

 // be warned, the options controller has its own seperate versions of these
    this.events = {
        changeProperty : lib_core.GuiEvents.CHANGE_PROPERTY,
        focus: lib_core.GuiEvents.INSPECTOR_FOCUS,
        enter: lib_core.GuiEvents.INSPECTOR_ENTER,
        blur: lib_core.GuiEvents.INSPECTOR_BLUR
    };
};
lib_core.inherit(InspectorController, lib_core.Controller);
InspectorController.inject = {
    editorController : AbstractEditorController,
    masterController : ui_extensions.MasterController
};

module.exports = InspectorController;

InspectorController.prototype.createModel = function () {

    var inspectorSubjectModel = this.parent().getModel();
    var editorModel = this.editorController.getModel();

    return new InspectorModel(editorModel, inspectorSubjectModel, this.configuration);
};

InspectorController.prototype.createView = function () {
    var editorModel = this.editorController.getModel();
    var editorView = this.editorController.getView();

    return new InspectorView(this.getModel(), this.rootStateMachine, editorModel, editorView, this.events, this.configuration);
};

InspectorController.prototype.createStateMachine = function () {
    return new InspectorStateMachine(this.root, this.getModel(), this.events);
};

InspectorController.prototype.afterLoad = function () {
    // TODO: since we hide inspector now do we need this creepy append?
    var self = this;
    var editorController = this.editorController;
    var stateMachineCreator = function(){
        return self.createStateMachine();
    };
    editorController.getStatemachine().append(this.name(), stateMachineCreator, /idle|.*moving.*/, null, lib_core.StateMachine.CIRCULAR, null);
};
